import { ArrowRotateRight, Xmark } from '@gravity-ui/icons';
import { Button, Icon } from '@gravity-ui/uikit';

import styles from './styles.module.scss';

interface SelectedFiltersProps {
	selectedFilters: string[];
	removeFilter: (filter: string) => void;
	resetFilters: () => void;
	isMobile: any;
}

export const SelectedFilters = ({ selectedFilters, removeFilter, resetFilters, isMobile }: SelectedFiltersProps) => {
	if (!selectedFilters || selectedFilters.length === 0) {
		return null;
	}

	return (
		<div className={styles.filters_container}>
			<div className={styles.filters_container__filters}>
				{selectedFilters.map((filter, key) => (
					<Button key={key} size="m" onClick={() => removeFilter(filter)}>
						{filter}
						<Icon data={Xmark} size={13} />
					</Button>
				))}
			</div>
			{isMobile ? (
				''
			) : (
				<Button size="m" onClick={resetFilters} view="outlined" className={styles.filters_container__reset_btn}>
					<Icon data={ArrowRotateRight} size={16} />
					Сбросить
				</Button>
			)}
		</div>
	);
};
